import { ErrorHandler } from '@angular/core';

export class GlobalErrorHandler implements ErrorHandler {
  handleError(error) {
    // your custom error handling logic
    console.error('Unhandled Exception: ', error);
  }
}
